import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { NEWS } from "@/data/content";

const CATS = ["Tutte", "Il Club", "Trasferte", "Eventi", "Mondo Inter"];

export default function News() {
  const [cat, setCat] = useState("Tutte");
  const items = cat === "Tutte" ? NEWS : NEWS.filter((n) => n.category === cat);

  return (
    <section id="news" data-testid="news-section" className="bg-secondary/40 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <span className="text-xs font-bold uppercase tracking-widest text-primary">News & Eventi</span>
            <h2 className="mt-3 font-display font-extrabold uppercase tracking-tight text-3xl md:text-4xl">
              Ultime dal club
            </h2>
          </div>
          <div data-testid="news-filter-tabs" className="flex flex-wrap gap-2">
            {CATS.map((c) => (
              <button
                key={c}
                data-testid={`news-filter-${c}`}
                onClick={() => setCat(c)}
                className={`rounded-full px-4 py-2 text-xs font-bold uppercase tracking-wide transition-colors ${
                  cat === c ? "bg-primary text-primary-foreground" : "bg-card border border-border hover:border-primary"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-10 grid md:grid-cols-12 gap-6">
          {items.map((n, i) => (
            <motion.article
              key={n.id}
              data-testid="news-item-card"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: (i % 3) * 0.08 }}
              className={`group overflow-hidden rounded-2xl border border-border bg-card hover:shadow-xl transition-all ${
                n.featured ? "md:col-span-8 md:row-span-2" : "md:col-span-4"
              }`}
            >
              <div className={`overflow-hidden ${n.featured ? "h-64 md:h-80" : "h-44"}`}>
                <img
                  src={n.image}
                  alt={n.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 text-xs font-bold uppercase tracking-widest">
                  <span className="text-primary">{n.category}</span>
                  <span className="text-muted-foreground">{n.date}</span>
                </div>
                <h3 className={`mt-2 font-display font-bold leading-tight ${n.featured ? "text-2xl" : "text-lg"}`}>
                  {n.title}
                </h3>
                <p className="mt-2 text-sm text-muted-foreground line-clamp-3">{n.excerpt}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-bold text-primary group-hover:gap-2 transition-all">
                  Leggi tutto <ArrowRight size={15} />
                </span>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
